function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/ui/colorinputview
 */
import { View, InputTextView, ButtonView, createDropdown, ColorGridView } from 'ckeditor5/src/ui';
import { icons } from 'ckeditor5/src/core';
import '../../theme/colorinput.css';
/**
 * The color input view class. It allows the user to type in a color (hex, rgb, etc.)
 * or choose it from the configurable color palette with a preview.
 *
 * @private
 * @extends module:ui/view~View
 */

var ColorInputView = /*#__PURE__*/function (_View) {
  _inherits(ColorInputView, _View);

  var _super = _createSuper(ColorInputView);

  /**
   * Creates an instance of the color input view.
   *
   * @param {module:utils/locale~Locale} locale The locale instance.
   * @param {Object} options The input options.
   * @param {module:ui/colorgrid/colorgrid~ColorDefinition} options.colorDefinitions The colors to be displayed
   * in the palette inside the input's dropdown.
   * @param {Number} options.columns The number of columns in which the colors will be displayed.
   * @param {String} [options.defaultColorValue] If specified, the color input view will replace the "Remove color" button with
   * the "Restore default" button. Instead of clearing the input field, the default color value will be set.
   */
  function ColorInputView(locale, options) {
    var _this;

    _classCallCheck(this, ColorInputView);

    _this = _super.call(this, locale);
    var bind = _this.bindTemplate;
    /**
     * The value of the input.
     *
     * @observable
     * @member {String} #value
     * @default ''
     */

    _this.set('value', '');
    /**
     * The `id` attribute of the input (i.e. to pair with the `<label>` element).
     *
     * @observable
     * @member {String} #id
     */


    _this.set('id');
    /**
     * Controls whether the input view is in read-only mode.
     *
     * @observable
     * @member {Boolean} #isReadOnly
     * @default false
     */


    _this.set('isReadOnly', false);
    /**
     * Set to `true` when the field has some error. Usually controlled via
     * {@link module:ui/labeledinput/labeledinputview~LabeledInputView#errorText}.
     *
     * @observable
     * @member {Boolean} #hasError
     * @default false
     */


    _this.set('hasError', false);
    /**
     * An observable flag set to `true` when the input is focused by the user.
     * `false` otherwise.
     *
     * @readonly
     * @observable
     * @member {Boolean} #isFocused
     * @default false
     */


    _this.set('isFocused', false);
    /**
     * An observable flag set to `true` when the input contains no text.
     *
     * @readonly
     * @observable
     * @member {Boolean} #isEmpty
     * @default true
     */


    _this.set('isEmpty', true);
    /**
     * The `id` of the element describing this field. When the field has
     * some error, it helps screen readers read the error text.
     *
     * @observable
     * @member {Boolean} #ariaDescribedById
     */


    _this.set('ariaDescribedById');
    /**
     * A cached reference to the options passed to the constructor.
     *
     * @member {Object}
     */


    _this.options = options;
    /**
     * An instance of the dropdown allowing to select a color from a grid.
     *
     * @protected
     * @member {module:ui/dropdown/dropdown~DropdownView}
     */

    _this._dropdownView = _this._createDropdownView();
    /**
     * An instance of the input allowing the user to type a color value.
     *
     * @protected
     * @member {module:ui/inputtext/inputtextview~InputTextView}
     */

    _this._inputView = _this._createInputTextView();
    /**
     * The flag that indicates whether the user is still typing.
     * If set to true, it means that the text input field ({@link #_inputView}) still has the focus.
     * So, we should interrupt the user by replacing the input's value.
     *
     * @protected
     * @member {Boolean}
     */

    _this._stillTyping = false;

    _this.setTemplate({
      tag: 'div',
      attributes: {
        class: ['ck', 'ck-input-color', bind.if('hasError', 'ck-error')],
        id: bind.to('id'),
        'aria-invalid': bind.if('hasError', true),
        'aria-describedby': bind.to('ariaDescribedById')
      },
      children: [_this._dropdownView, _this._inputView]
    });

    _this.on('change:value', function (evt, name, inputValue) {
      return _this._setInputValue(inputValue);
    });

    return _this;
  }
  /**
   * Focuses the input.
   */


  _createClass(ColorInputView, [{
    key: "focus",
    value: function focus() {
      this._inputView.focus();
    }
    /**
     * Creates and configures the {@link #_dropdownView}.
     *
     * @private
     */

  }, {
    key: "_createDropdownView",
    value: function _createDropdownView() {
      var locale = this.locale;
      var t = locale.t;
      var bind = this.bindTemplate;

      var colorGrid = this._createColorGrid(locale);

      var dropdown = createDropdown(locale);
      var colorPreview = new View();

      var removeColorButton = this._createRemoveColorButton();

      colorPreview.setTemplate({
        tag: 'span',
        attributes: {
          class: ['ck', 'ck-input-color__button__preview'],
          style: {
            backgroundColor: bind.to('value')
          }
        },
        children: [{
          tag: 'span',
          attributes: {
            class: ['ck', 'ck-input-color__button__preview__no-color-indicator', bind.if('value', 'ck-hidden', function (value) {
              return value != '';
            })]
          }
        }]
      });
      dropdown.buttonView.extendTemplate({
        attributes: {
          class: 'ck-input-color__button'
        }
      });
      dropdown.buttonView.children.add(colorPreview);
      dropdown.buttonView.tooltip = t('Color picker');
      dropdown.panelPosition = locale.uiLanguageDirection === 'rtl' ? 'se' : 'sw';
      dropdown.panelView.children.add(removeColorButton);
      dropdown.panelView.children.add(colorGrid);
      dropdown.bind('isEnabled').to(this, 'isReadOnly', function (value) {
        return !value;
      });
      return dropdown;
    }
    /**
     * Creates and configures an instance of {@link module:ui/inputtext/inputtextview~InputTextView}.
     *
     * @private
     * @returns {module:ui/inputtext/inputtextview~InputTextView} A configured instance to be set as {@link #_inputView}.
     */

  }, {
    key: "_createInputTextView",
    value: function _createInputTextView() {
      var _this2 = this;

      var locale = this.locale;
      var inputView = new InputTextView(locale);
      inputView.extendTemplate({
        on: {
          blur: inputView.bindTemplate.to('blur')
        }
      });
      inputView.value = this.value;
      inputView.bind('isReadOnly', 'hasError').to(this);
      this.bind('isFocused', 'isEmpty').to(inputView);
      inputView.on('input', function () {
        var inputValue = inputView.element.value; // Check if the value matches one of our defined colors' label.

        var mappedColor = _this2.options.colorDefinitions.find(function (def) {
          return inputValue === def.label;
        });

        _this2._stillTyping = true;
        _this2.value = mappedColor && mappedColor.color || inputValue;
      });
      inputView.on('blur', function () {
        _this2._stillTyping = false;

        _this2._setInputValue(inputView.element.value);
      });
      inputView.delegate('input').to(this);
      return inputView;
    }
    /**
     * Creates and configures the button that clears the color.
     *
     * @private
     */

  }, {
    key: "_createRemoveColorButton",
    value: function _createRemoveColorButton() {
      var _this3 = this;

      var locale = this.locale;
      var t = locale.t;
      var removeColorButton = new ButtonView(locale);
      var defaultColor = this.options.defaultColorValue || '';
      var removeColorButtonLabel = defaultColor ? t('Restore default') : t('Remove color');
      removeColorButton.class = 'ck-input-color__remove-color';
      removeColorButton.withText = true;
      removeColorButton.icon = icons.eraser;
      removeColorButton.label = removeColorButtonLabel;
      removeColorButton.on('execute', function () {
        _this3.value = defaultColor;
        _this3._dropdownView.isOpen = false;

        _this3.fire('input');
      });
      return removeColorButton;
    }
    /**
     * Creates and configures the color grid inside the {@link #_dropdownView}.
     *
     * @private
     */

  }, {
    key: "_createColorGrid",
    value: function _createColorGrid(locale) {
      var _this4 = this;

      var colorGrid = new ColorGridView(locale, {
        colorDefinitions: this.options.colorDefinitions,
        columns: this.options.columns
      });
      colorGrid.on('execute', function (evtData, data) {
        _this4.value = data.value;
        _this4._dropdownView.isOpen = false;

        _this4.fire('input');
      });
      colorGrid.bind('selectedColor').to(this, 'value');
      return colorGrid;
    }
    /**
     * Sets {@link #_inputView}'s value property to the color value or color label,
     * if there is one and the user is not typing.
     *
     * Handles cases like:
     *
     * * Someone picks the color in the grid.
     * * The color is set from the plugin level.
     *
     * @private
     * @param {String} inputValue Color value to be set.
     */

  }, {
    key: "_setInputValue",
    value: function _setInputValue(inputValue) {
      if (!this._stillTyping) {
        var normalizedInputValue = normalizeColor(inputValue); // Check if the value matches one of our defined colors.

        var mappedColor = this.options.colorDefinitions.find(function (def) {
          return normalizedInputValue === normalizeColor(def.color);
        });

        if (mappedColor) {
          this._inputView.value = mappedColor.label;
        } else {
          this._inputView.value = inputValue || '';
        }
      }
    }
  }]);

  return ColorInputView;
}(View); // Normalizes color value, by stripping extensive whitespace.
// For example., transforms:
// * `   rgb(  25 50    0 )` to `rgb(25 50 0)`,
// * "\t  rgb(  25 ,  50,0 )		" to `rgb(25 50 0)`.
//
// @param {String} colorString The value to be normalized.
// @returns {String}


export { ColorInputView as default };

function normalizeColor(colorString) {
  return colorString // Remove any whitespace right after `(` or `,`.
  .replace(/([(,])\s+/g, '$1') // Remove any whitespace at the beginning or right before the end, `)`, `,`, or another whitespace.
  .replace(/^\s+|\s+(?=[),\s]|$)/g, '') // Then, replace `,` or whitespace with a single space.
  .replace(/,|\s/g, ' ');
}